<template>
  <div class="course-content" v-loading="!data.course">
    <template v-if="data.course">
      <div class="container content">
        <div class="card card-shadow">
          <el-image class="cover" fit="cover" :src="data.course.cover"></el-image>
          <div class="info">
            <h1>{{ data.course.name }}</h1>
            <div>
              <span class="info-item">课程负责人：{{ data.course.creatorName }}</span>
              <span class="info-item">所属学院：{{ data.course.academyName || '马克思主义学院' }}</span>
            </div>
            <div>
              <span class="info-item">班级数量：{{ data.course.classNum }}</span>
              <span class="info-item">开课时间：{{ timeFormat(data.course.beginDate) }}</span>
            </div>
            <el-button class="view-btn pc" type="danger" @click="viewCourse">加入课程</el-button>
          </div>
        </div>
        <div class="row">
          <el-row :gutter="40">
            <el-col :sm="18">
              <div class="course-content-1 card-shadow">
                <div class="content-block">
                  <h1>所用教材</h1>
                  <div class="textbook-list">
                    <div class="textbook-item" v-for="(item, index) in data.textbook" :key="index">
                      <i class="iconfont iconjiaocai"></i>
                      <div class="textbook-info">
                        <div class="name">{{ item.name }}</div>
                        <div class="creator">作者：{{ item.creatorName }}</div>
                      </div>
                    </div>
                    <div class="empty-tip-1" v-if="data.textbook.length == 0">暂无教材</div>
                  </div>
                </div>

                <div class="content-block">
                  <h1>课程公告</h1>
                  <div class="content-list">
                    <div
                      class="content-item"
                      :class="{ 'first': index === 0 }"
                      v-for="(item, index) in data.announcement"
                      :key="index"
                    >
                      <i class="iconfont iconkechenggonggao"></i>
                      <div class="content-info">
                        <div class="name">{{ index + 1 }}.{{ item.subject }}</div>
                        <div class="info">
                          <span>发布人：{{ item.creatorName }}</span>
                          <span class="ml-10">发布时间：{{ timeFormat(item.createDate) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="empty-tip-1" v-if="data.announcement.length == 0">暂无公告</div>
                  </div>
                </div>

                <div class="content-block">
                  <h1>
                    教学活动
                    <span class="block-tip">（请登录后进入课程参与课程活动）</span>
                  </h1>
                  <div>
                    <h2>作业</h2>
                    <div class="content-list">
                      <div
                        class="content-item"
                        :class="{ 'first': index === 0 }"
                        v-for="(item, index) in data.homeworks"
                        :key="index"
                      >
                        <i class="iconfont iconzuoye"></i>
                        <div class="content-info">
                          <div class="name">{{ index + 1 }}.{{ item.homeworkTitle }}</div>
                          <div class="info">
                            <span>发布人：{{ item.teacherName }}</span>
                            <span
                              class="ml-10"
                            >{{ timeFormat(item.startTime) }} ~ {{ timeFormat(item.endTime) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="empty-tip-1" v-if="data.homeworks.length == 0">暂无作业</div>
                    </div>
                  </div>
                  <div>
                    <h2>讨论</h2>
                    <div class="content-list">
                      <div
                        class="content-item"
                        :class="{ 'first': index === 0 }"
                        v-for="(item, index) in data.discussion"
                        :key="index"
                      >
                        <i class="iconfont icontaolun"></i>
                        <div class="content-info">
                          <div class="name">{{ index + 1 }}.{{ item.title }}</div>
                          <div class="info">
                            <span>发布人：{{ item.userName }}</span>
                            <span class="ml-10">开始时间：{{ timeFormatHH(item.startTime) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="empty-tip-1" v-if="data.discussion.length == 0">暂无讨论</div>
                    </div>
                  </div>
                  <div>
                    <h2>考试</h2>
                    <div class="content-list">
                      <div
                        class="content-item"
                        :class="{ 'first': index === 0 }"
                        v-for="(item, index) in data.exams"
                        :key="index"
                      >
                        <i class="iconfont iconkaoshi"></i>
                        <div class="content-info">
                          <div class="name">{{ index + 1 }}.{{ item.title }}</div>
                          <div class="info">
                            <span>发布人：{{ item.creatorName }}</span>
                            <span
                              class="ml-10"
                            >{{ timeFormat(item.startTime) }} ~ {{ timeFormat(item.endTime) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="empty-tip-1" v-if="data.exams.length == 0">暂无考试</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :sm="6">
              <div class="course-teacher card-shadow">
                <h1>教学团队</h1>
                <div class="teacher-list">
                  <div class="teacher-item" v-for="(item, index) in data.teachingTeam" :key="index">
                    <el-image
                      class="cover"
                      fit="cover"
                      :src="buildResourcePath(item.headImage) || 'https://www.ulearning.cn/common/img/defaultHeaderSm.png'"
                    ></el-image>
                    <span class="name">{{ item.name }}</span>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { spocCourseContent2 } from "@/api/api.js";
import util from "@/libs/util.js";

export default {
  name: "courseContent",
  props: ["id"],
  data() {
    return {
      data: {}
    };
  },
  created() {
    spocCourseContent2(this.id)
      .then(res => {
        // 返回数据
        this.data = res.result;
      })
      .catch(err => {
        // 异常情况
        console.log(err);
      });
  },
  methods: {
    viewCourse() {
      // 判断登录状态
      let userInfo = util.getCookie("USER_INFO");
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
      }

      if (userInfo && userInfo.userId) {
        window.open(
          "https://www.ulearning.cn/ulearning/index.html#/joinCourse/spoc"
        );
      } else {
        this.$message({
          showClose: true,
          message: "请先登录",
          type: "warning"
        });
      }
    },
    buildResourcePath: util.buildResourcePath,
    timeFormat(value) {
      return util.timeFormat(value, "yyyy年MM月dd日");
    },
    timeFormatHH(value) {
      return util.timeFormat(value, "yyyy年MM月dd日 hh:mm");
    }
  }
};
</script>

<style scoped>
.content {
  margin-top: 30px;
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 10px;
}

.card {
  position: relative;
  padding: 20px;
  background-color: #fff;
}

.card .cover {
  position: absolute;
  width: 360px;
  height: 203px;
  background-color: #eee;
}

.card .info {
  min-height: 203px;
  padding-left: 380px;
}

.card h1 {
  margin-bottom: 16px;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  overflow: hidden;
}

.card .info-item {
  margin-bottom: 14px;
  display: inline-block;
  width: 220px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}

.card .view-btn {
  margin-top: 48px;
  width: 224px;
}

.row {
  margin-top: 20px;
}

.course-content-1,
.course-teacher {
  padding: 32px 20px;
  background-color: #fff;
}

.row h1 {
  margin-bottom: 20px;
  margin-left: -20px;
  padding-left: 17px;
  line-height: 20px;
  font-size: 18px;
  border-left: 3px solid #ec2f08;
}

.row h2 {
  margin: 20px 0 10px 0;
  padding: 0 18px;
  line-height: 38px;
  font-size: 16px;
  color: #ff8700;
  background-color: rgba(255, 175, 42, 0.1);
}

.content-block {
  margin-bottom: 30px;
}

.block-tip {
  margin-left: 20px;
  font-size: 14px;
  font-weight: normal;
  color: #888;
  vertical-align: bottom;
}

.empty-tip-1 {
  font-size: 14px;
  color: #888;
}

.textbook-item {
  margin-right: 32px;
  display: inline-block;
  vertical-align: middle;
}

.textbook-item .iconfont,
.textbook-item .textbook-info {
  margin-left: 10px;
  display: inline-block;
  vertical-align: middle;
}
.textbook-item .iconfont {
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 13px;
  background-color: #ffaf2a;
  color: #fff;
  text-align: center;
  border-radius: 100%;
}

.textbook-item .name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  overflow: hidden;
}

.textbook-item .creator {
  margin-top: 4px;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: #888;
  overflow: hidden;
}

.content-item .iconfont,
.content-item .content-info {
  display: inline-block;
  vertical-align: top;
}

.content-item .content-info {
  margin-left: -22px;
  padding-left: 22px;
  width: 100%;
  box-sizing: border-box;
}

.content-item {
  padding: 10px 0;
  border-top: 1px solid #e9e9e9;
}

.content-item.first {
  border-top: unset;
}

.content-item .iconfont {
  margin-right: 10px;
  font-size: 12px;
  line-height: 20px;
  color: #e3e3e3;
}

.content-info .name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  overflow: hidden;
}

.content-info .info {
  margin-top: 6px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: #888;
  overflow: hidden;
}

.teacher-list {
  margin-bottom: -20px;
}

.teacher-item {
  margin-bottom: 20px;
}

.teacher-item .cover {
  margin-right: 10px;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background-color: #eee;
  vertical-align: middle;
  overflow: hidden;
}

.teacher-item .name {
  line-height: 20px;
}

@media (max-width: 767px) {
  .content {
    margin-top: 15px;
    margin-bottom: 30px;
  }

  .card {
    padding: 0;
  }

  .card .cover {
    position: unset;
    width: 100%;
  }

  .card .info {
    min-height: unset;
    padding-left: 0;
  }

  .card h1 {
    margin-top: 16px;
    margin-bottom: unset;
    line-height: 24px;
    font-size: 18px;
    overflow: unset;
  }

  .card .info-item {
    margin-top: 12px;
    display: block;
    width: unset;
    height: 12px;
    line-height: 12px;
    font-size: 12px;
  }

  .row h1 {
    margin-left: -0;
    padding-left: 0;
    font-size: 16px;
    border-left: 0;
  }

  .row h1:before {
    content: "";
    display: inline-block;
    margin-top: 1px;
    margin-right: 10px;
    width: 3px;
    height: 16px;
    background-color: #ec2f08;
    vertical-align: top;
  }

  .course-content-1,
  .course-teacher {
    padding: 15px 0;
  }
}
</style>
